module.exports = __webpack_public_path__ + "static/media/AestheticsF.9fad7a26.png";